// 取当前时间


export function getYmdHm() {
    let d = new Date()
    let y = d.getFullYear()
    let m = (d.getMonth() + 1).toString()
    let day = d.getDate().toString()
    let h = d.getHours().toString()
    let min = d.getMinutes().toString().padStart(2, '0')
    return `${y}年${m}月${day}日 ${h}点${min}分`
}

// 取随机最小最大值
export function getRandomInt(min, max) {

    return Math.floor(Math.random() * (parseInt(max) - parseInt(min) + 1)) + parseInt(min)
}

export function eSend(type,data){
    try {
        window.chrome.webview.postMessage({type,data})
    }catch (e){ }
}

export function randomText(text) {
    // 随机取数组元素
    const randomItem = (arr) => arr[Math.floor(Math.random() * arr.length)];

    // 替换所有 【内容】 为随机词语
    return text.replace(/【([^】]+)】/g, (_, content) => {
        const list = content.split(/\s+/).filter(Boolean);
        return randomItem(list);
    });
}

export function parseUrl(type, url) {
    switch (type) {
        case "douyin":
            var reg = /live\.douyin\.com\/(\d+)/;
            var match = url.match(reg);
            var liveId = match ? match[1] : '';
            return liveId;

            break;
        case "tiktok":
            var reg = /www\.tiktok\.com\/@(.*?)\//;
            var match = url.match(reg);
            var liveId = match ? match[1] : '';
            return liveId;
            break;
    }


}


export async function delay(ms) {

    return new Promise(resolve =>{
        setTimeout(resolve, ms)
    })
}



// 随机名称 测试用
export function getDouyinName() {
    let a = ['晚', '凉', '屿', '初', '念', '清', '枕', '寻', '赴', '浅']
    let b = ['风', '月', '星', '川', '野', '言', '安', '雾', '禾', '眠']
    let c = ['辞', '兮', '屿', '染', '柒', '洛', '汐', '凡']
    let x = a[Math.floor(Math.random() * a.length)]
    let y = b[Math.floor(Math.random() * b.length)]
    let z = c[Math.floor(Math.random() * c.length)]
    return x + y + z
}


export function checkAuduiSrc(audio) {

    return audio.src.indexOf("blob") < 0 ? false : true;

}
export function extractChineseCharacters(str) {
    // 使用正则表达式匹配所有的汉字
    const regex = /[\u4e00-\u9fff\u3400-\u4DBF\uF900-\uFAFF\u3300-\u33FF\uFE30-\uFE4F\uFF00-\uFFEF]+/g;
    const matches = str.match(regex);

    if (matches) {
        // 输出所有匹配的汉字
        return matches.join('');
    } else {
        return ''
    }
}